/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Enum representing the type of agent.
 */
export enum AgentType {
  /**
   * Represents a published agent.
   */
  Published = 'Published',
  /**
   * Represents a prebuilt agent.
   */
  Prebuilt = 'Prebuilt',
}
